fx.ns("filters.photofilters", class BlurFilter extends filters.photofilters.BaseFilter{
    
    constructor(parameters)
    {
        super(parameters);

        this.amount = this.params.amount;
        
    };

 
	filterFCN(add)
	{
		 add.gaussianBlur(this.amount)
	}

    

});
